/**
 * Enumeration of the diffrent Module Types
 * @author Louis Scheepers
 */
export class ModuleType {
    static NONE = 0;
    static CICO = 1;
    static INO = 2;
    static AVD = 3;
    static PL = 4;
    static BS = 5;
    static CFS = 6;
    static AR = 7;
    static DDO = 8;
    static TCS = 9;
    static RET = 10;
    static AP = 11;
    static CDO = 12;
    static TSP = 13;
    static IM = 14;
    static INAS = 15;
    static INAQ = 16;
    static PLR = 17;
    static BSR = 18;

    /**
     * Maps the values to the string version of the type
     * @returns {{ret: number, bsr: number, im: number, inaq: number, tcs: number, inas: number, ino: number, avd: number, ddo: number, ap: number, cdo: number, tsp: number, bs: number, cfs: number, ar: number, plr: number, cico: number, pl: number}}
     */
    static valuesFromType() {
        return {
            'cico': 1,
            'ino': 2,
            'avd': 3,
            'pl': 4,
            'bs': 5,
            'cfs': 6,
            'ar': 7,
            'ddo': 8,
            'tcs': 9,
            'ret': 10,
            'ap': 11,
            'cdo': 12,
            'tsp': 13,
            'im': 14,
            'inas': 15,
            'inaq': 16,
            'plr': 17,
            'bsr': 18,
        }
    }
}